/**
 * Mod: Resource Loader Config
 * Time: 2021-08-04 13:34:00
 */
export default {
  loading: [
    {
      key: 'loading_ip_png',
      path: require('@/assets/loading/loading-ip.png')
    },
    {
      key: 'loading_chest_png',
      path: require('@/assets/loading/loading-chest.png')
    },
    {
      key: 'loading_text_png',
      path: require('@/assets/loading/loading-text.png')
    }
  ],
  main: [
    {
      key: 'btn_red_short_png',
      path: require('@/assets/ico/btn-red-short.png')
    },
    {
      key: 'btn_red_png',
      path: require('@/assets/ico/btn-red.png')
    },
    {
      key: 'btn_white_short_png',
      path: require('@/assets/ico/btn-white-short.png')
    },
    {
      key: 'btn_white_png',
      path: require('@/assets/ico/btn-white.png')
    },
    {
      key: 'ico_chest_1_png',
      path: require('@/assets/ico/ico-chest-1.png')
    },
    {
      key: 'ico_chest_2_png',
      path: require('@/assets/ico/ico-chest-2.png')
    },
    {
      key: 'ico_chest_3_png',
      path: require('@/assets/ico/ico-chest-3.png')
    },
    {
      key: 'ico_chest_4_png',
      path: require('@/assets/ico/ico-chest-4.png')
    },
    {
      key: 'ico_chest_blue_disabled_png',
      path: require('@/assets/ico/ico-chest-blue-disabled.png')
    },
    {
      key: 'ico_chest_blue_png',
      path: require('@/assets/ico/ico-chest-blue.png')
    },
    {
      key: 'ico_chest_gold_disabled_png',
      path: require('@/assets/ico/ico-chest-gold-disabled.png')
    },
    {
      key: 'ico_chest_gold_png',
      path: require('@/assets/ico/ico-chest-gold.png')
    },
    {
      key: 'ico_close_png',
      path: require('@/assets/ico/ico-close.png')
    },
    {
      key: 'ico_moneychest_blue_png',
      path: require('@/assets/ico/ico-moneychest-blue.png')
    },
    {
      key: 'ico_moneychest_gold_png',
      path: require('@/assets/ico/ico-moneychest-gold.png')
    },
    {
      key: 'ico_music_png',
      path: require('@/assets/ico/ico-music.png')
    },
    {
      key: 'ico_person_png',
      path: require('@/assets/ico/ico-person.png')
    },
    {
      key: 'ico_point_png',
      path: require('@/assets/ico/ico-point.png')
    },
    {
      key: 'ico_qrcode_jpg',
      path: require('@/assets/ico/ico-qrcode.jpg')
    },
    {
      key: 'ico_redenvelope_bg_png',
      path: require('@/assets/ico/ico-redenvelope-bg.png')
    },
    {
      key: 'ico_redenvelope_disabled_png',
      path: require('@/assets/ico/ico-redenvelope-disabled.png')
    },
    {
      key: 'ico_redenvelope_png',
      path: require('@/assets/ico/ico-redenvelope.png')
    },
    {
      key: 'ico_rule_png',
      path: require('@/assets/ico/ico-rule.png')
    },
    {
      key: 'ico_share_wx_png',
      path: require('@/assets/ico/ico-share-wx.png')
    },
    {
      key: 'ico_share_png',
      path: require('@/assets/ico/ico-share.png')
    },
    {
      key: 'ico_tips_png',
      path: require('@/assets/ico/ico-tips.png')
    },
    {
      path: require('@/assets/index/bg-1.jpg')
    },
    {
      path: require('@/assets/index/bg-2.jpg')
    },
    {
      path: require('@/assets/index/bg-3.jpg')
    },
    {
      path: require('@/assets/loading/loading-bg.jpg')
    }
  ]
}
